import { threeColumnTeams as schema } from 'web/schemas/contentful/_schema.mjs';
import { fakeProps } from 'web/schemas/contentfulTestData';

const TestData = {
  eyebrow: 'Expert Advisors',
  header: "We'll help you find your way.",
  bodyText:
    "At Engel & Völkers, we're here to exceed your expectations. Our Advisors have a deep understanding of the Denver real estate market and tailor their expertise to suit your every need.",
  people: [
    {
      key: '77ppORWtzUQZxUr3X1Likf',
      alt_text: 'Advisor',
      img: '//images.ctfassets.net/3g4b24b0tvoz/3mN5uBO27gfb5effkPd3PH/d30c30feed6fc4848cc3ea856033ce6c/Image3.jpg',
    },
    {
      key: '8EKHJO7vHTbAwEXatvqLg',
      alt_text: 'Advisor',
      img: '//images.ctfassets.net/3g4b24b0tvoz/3vwqPdSCts9RTDYlQXfw32/c92a62f9d4e57dc9dd4211400c06a44d/Image2.jpg',
    },
    {
      key: '4WvUsHBVrzIJ1lKiYOrwtT',
      alt_text: 'Advisor',
      img: '//images.ctfassets.net/3g4b24b0tvoz/Rt0EMKblxx5YAoSatkkaL/2d46ba4bb209f9c283e27ab7dfc7770c/Image1.jpg',
    },
  ],
  ctaText: 'Meet Our Team',
  ctaUrl: '#',
};

export default fakeProps(schema, TestData);
